import { render, staticRenderFns } from "./ClassicAntimatterDimensionsTab.vue?vue&type=template&id=53a231ee&scoped=true&"
import script from "./ClassicAntimatterDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./ClassicAntimatterDimensionsTab.vue?vue&type=script&lang=js&"
import style0 from "./ClassicAntimatterDimensionsTab.vue?vue&type=style&index=0&id=53a231ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a231ee",
  null
  
)

export default component.exports